<div>
  <app-chart-labels-filter
    (search)="searchDialogs($event)">
  </app-chart-labels-filter>
  <mat-divider></mat-divider>
  <app-chart-labels-table *ngIf="dialogs"
                          [chartLabels]="dialogs.content"
                          [page]="dialogs.number"
                          [pageSize]="dialogs.size"
                          [totalElements]="dialogs.totalElements"
                          (loadChartLabels)="loadChartLabels($event)">
  </app-chart-labels-table>
</div>
